import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IDashboard = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="12"
            viewBox="0 0 24 12"
            fill={props.color ?? '#37474F'}
          >
            <mask id="path-1-inside-1_63_4048" fill={props.color ?? '#37474F'}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12H24Z"
              />
            </mask>
            <path
              d="M24 12V14H26V12H24ZM0 12H-2V14H0V12ZM12 2C17.5228 2 22 6.47715 22 12H26C26 4.26801 19.732 -2 12 -2V2ZM2 12C2 6.47715 6.47715 2 12 2V-2C4.26801 -2 -2 4.26801 -2 12H2ZM0 14H24V10H0V14Z"
              fill={props.color ?? '#37474F'}
              mask="url(#path-1-inside-1_63_4048)"
            />
            <mask id="path-3-inside-2_63_4048" fill={props.color ?? '#37474F'}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 11.5C15 9.84315 13.6569 8.5 12 8.5C10.3431 8.5 9 9.84315 9 11.5H15Z"
              />
            </mask>
            <path
              d="M15 11.5V13.5H17V11.5H15ZM9 11.5H7V13.5H9V11.5ZM12 10.5C12.5523 10.5 13 10.9477 13 11.5H17C17 8.73858 14.7614 6.5 12 6.5V10.5ZM11 11.5C11 10.9477 11.4477 10.5 12 10.5V6.5C9.23858 6.5 7 8.73858 7 11.5H11ZM9 13.5H15V9.5H9V13.5Z"
              fill={props.color ?? '#37474F'}
              mask="url(#path-3-inside-2_63_4048)"
            />
            <line
              x1="13.5883"
              y1="5.88252"
              x2="12.8825"
              y2="9.41165"
              stroke={props.color ?? '#37474F'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IDashboard;
